// ①のコード（スクロールに応じてボタンを表示・非表示）
document.addEventListener("DOMContentLoaded", function() {
  var button = document.querySelector(".CustomizedFixedBox");
  var scrollStartPosition = 100; // スクロールが開始される位置（例：100px）

  function toggleButtonVisibility() {
    if (window.scrollY >= scrollStartPosition) {
      button.style.bottom = "18px"; // スクロールが開始されたら表示
      button.classList.add("show-button"); // クラスを追加してボタンを表示
    } else {
      button.style.bottom = "-250px"; // スクロールが指定位置より上に戻ったら非表示
      button.classList.remove("show-button"); // クラスを削除してボタンを非表示
    }
  }

  function hideButton() {
    button.style.bottom = "-250px"; // ボタンを初期位置（見えない位置）に戻す
    button.classList.remove("show-button"); // クラスを削除してボタンを非表示
  }

  // 初期状態でボタンを非表示にする
  button.style.bottom = "-250px";

  window.addEventListener("scroll", toggleButtonVisibility);
  window.addEventListener("resize", hideButton); // ウィンドウサイズが変更された時にもボタンを非表示にする
});

// ②のコード（文字アニメーション）
window.addEventListener('DOMContentLoaded', function() {
  setTimeout(function () {
    var text_wrap = '.mv_text'; //pタグのクラス
    var delay_speed = 120; //文字が出るスピード(ミリ秒)
    var fade_speed = 600; //文字がフェードするスピード(ミリ秒)
    var str;
    $(text_wrap).css('opacity','1');
    var firsttxt = $(text_wrap).html();
    str = firsttxt.replace(/<br>/g,'\n');
    $(text_wrap).html('');
    for (var i = 0; i < str.length; i++) {
      $(text_wrap).append('<span class="text_span">'+str.substr(i, 1).replace(/\n/, "<br>")+'</span>');
      $(text_wrap).children('span:last-child').delay(delay_speed * i).animate({opacity:'1'}, fade_speed);
    }
    setTimeout(function(){$(text_wrap).html(firsttxt)},str.length*delay_speed+fade_speed);
  }, 1000);
});
